import styled from '@emotion/styled';

export const StyledList = styled.ul`
    list-style: none;
`;

export const StyledHeader = styled.div`
    /*
    This is a workaround to fix the clipping on the BackButton
    */

    height: 44px;
    display: flex;
    align-items: center;
`;
